import styled, { keyframes, createGlobalStyle } from "styled-components";

export const GlobalScrollbarStyle = createGlobalStyle`
  .logo-scroll-container,
  .carousel-container,
  .trust-roll-container {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
    
    &::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
  }
`;

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const fadeInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const circleMoveLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const circleMoveRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const floatAnimation = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0); }
`;

export const AboutRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 160px 0 0;
  min-height: 100vh;
  position: relative;
  overflow: visible;
  
  @media (max-width: 768px) {
    padding: 100px 0 0;
    box-sizing: border-box;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 40px;
  width: 100%;
  opacity: 0;
  animation: ${fadeInUp} 1s forwards;
  box-sizing: border-box;
  padding: 0 240px;
  
  @media (max-width: 1920px) {
    padding: 0 240px;
  }
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 40px;
    padding: 0 20px;
  }
`;

export const TitleText = styled.h1`
  color: #1D1D1D;
  font-size: 72px;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  line-height: 96px;
  word-wrap: break-word;
  word-break: keep-all;
  overflow-wrap: break-word;
  margin: 0;
  padding: 0;
  width: 100%;
  
  .pc-br {
    display: block;
  }
  
  @media (max-width: 1920px) {
    .pc-br {
      display: block;
    }
  }
  
  @media (max-width: 1440px) {
    font-size: 52px;
    line-height: 70px;
    
    .pc-br {
      display: block;
    }
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 32px;
    
    .pc-br {
      display: none;
    }
  }
`;

export const HighlightSpan = styled.span`
  color: #FF4F00;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
`;

export const HighlightText = styled.h1`
  color: #FF4F00;
  font-size: 72px;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  line-height: 96px;
  word-wrap: break-word;
  word-break: keep-all;
  overflow-wrap: break-word;
  margin: 0;
  padding: 0;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const AboutImage = styled.div`
  width: 100vw;
  height: 627px;
  background-color: #F8F8F8;
  position: relative;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 1600px) {
    height: 650px;
  }
  
  @media (max-width: 1400px) {
    height: 600px;
  }
  
  @media (max-width: 1200px) {
    height: 550px;
  }
  
  @media (max-width: 992px) {
    height: 500px;
  }
  
  @media (max-width: 768px) {
    height: 400px;
    margin-top: 0;
  }
`;

export const CenterImage = styled.img`
  width: 480px;
  height: auto;
  object-fit: contain;
  opacity: 0;
  animation: ${fadeIn} 1.5s ease forwards;
  animation-delay: 0.3s;
  position: relative;
  top: -95px;
  
  @media (max-width: 1600px) {
    width: 420px;
    top: -85px;
  }
  
  @media (max-width: 1400px) {
    width: 380px;
    top: -80px;
  }
  
  @media (max-width: 1200px) {
    width: 330px;
    top: -70px;
  }
  
  @media (max-width: 992px) {
    width: 300px;
    top: -65px;
  }
  
  @media (max-width: 768px) {
    width: 240px;
    top: -55px;
  }
`;

export const SideImage = styled.img<{ direction?: string }>`
  width: auto;
  height: 270px;
  object-fit: contain;
  opacity: 0;
  animation: ${props => props.direction === 'left' ? fadeInLeft : props.direction === 'right' ? fadeInRight : fadeIn} 1.5s ease forwards;
  animation-delay: ${props => props.direction === 'left' ? '1.0s' : '1.6s'};
  position: absolute;
  
  @media (max-width: 1600px) {
    height: 230px;
  }
  
  @media (max-width: 1400px) {
    height: 210px;
  }
  
  @media (max-width: 1200px) {
    height: 180px;
  }
  
  @media (max-width: 992px) {
    height: 160px;
  }
  
  @media (max-width: 768px) {
    height: 120px;
  }
`;

export const DotImage = styled.img<{ left?: string, top?: string, delay?: string, direction?: string, group?: string }>`
  position: absolute;
  width: 18px;
  height: 18px;
  left: ${props => props.left || '0'};
  top: ${props => props.top || '0'};
  opacity: 0;
  animation: ${props => {
    if (props.group === 'left-circles') return circleMoveLeft;
    if (props.group === 'right-circles') return circleMoveRight;
    return props.direction === 'left' ? fadeInLeft : props.direction === 'right' ? fadeInRight : fadeIn;
  }} 1.2s ease forwards;
  animation-delay: ${props => props.delay || '1s'};
  
  @media (max-width: 1600px) {
    width: 16px;
    height: 16px;
  }
  
  @media (max-width: 1400px) {
    width: 14px;
    height: 14px;
  }
  
  @media (max-width: 1200px) {
    width: 12px;
    height: 12px;
  }
  
  @media (max-width: 992px) {
    width: 10px;
    height: 10px;
  }
  
  @media (max-width: 768px) {
    width: 8px;
    height: 8px;
  }
`;

export const AnimationContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AnimationItem = styled.img<{ delay?: string, duration?: string, top?: string, left?: string, size?: string }>`
  position: absolute;
  top: ${props => props.top || '50%'};
  left: ${props => props.left || '50%'};
  transform: translate(-50%, -50%);
  width: ${props => props.size || 'auto'};
  height: auto;
  opacity: 0;
  animation: ${fadeIn} 1s forwards, ${floatAnimation} ${props => props.duration || '6s'} ease-in-out infinite;
  animation-delay: ${props => props.delay || '0.5s'};
`;

export const TextRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  
  @media (max-width: 1300px) {
    flex-wrap: wrap;
  }
  
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  width: 100%;
  padding: 0 240px;
  margin: 120px auto 0;
  opacity: 0;
  animation: ${fadeInUp} 1s forwards;
  animation-delay: 0.5s;
  box-sizing: border-box;
  gap: 40px;
  overflow: visible;
  
  @media (max-width: 1920px) {
    padding: 0 240px;
  }
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    margin: 40px auto 0;
    padding: 0 20px;
    gap: 0px;
  }
`;

export const LeftColumn = styled.div`
  width: 689px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    width: 689px;
  }
  
  @media (max-width: 1700px) {
    width: calc((100% - 40px) * 0.49);
  }
  
  @media (max-width: 1440px) {
    width: calc((100% - 40px) * 0.49);
  }
  
  @media (max-width: 768px) {
    margin-bottom: 0;
    width: 100%;
  }
`;

export const RightColumn = styled.div`
  width: 711px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    width: 711px;
  }
  
  @media (max-width: 1700px) {
    width: calc((100% - 40px) * 0.51);
  }
  
  @media (max-width: 1440px) {
    width: calc((100% - 40px) * 0.51);
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DescriptionText = styled.p`
  color: #1D1D1D;
  width: 100%;
  font-size: 32px;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  line-height: 46px;
  word-wrap: break-word;
  word-break: keep-all;
  overflow-wrap: break-word;
  margin: 0;
  letter-spacing: -0.01em;
  
  br.desc-br {
    display: block;
  }
  
  @media (max-width: 1500px) and (min-width: 1400px) {
    font-size: 30px;
    line-height: 44px;
    
    br.desc-br {
      display: block;
    }
  }
  
  @media (max-width: 1399px) and (min-width: 769px) {
    font-size: 28px;
    line-height: 42px;
    
    br.desc-br {
      display: inline;
      content: ' ';
      
      &::after {
        content: ' ';
      }
    }
  }
  
  @media (max-width: 1100px) and (min-width: 769px) {
    font-size: 26px;
    line-height: 40px;
  }
  
  @media (max-width: 900px) and (min-width: 769px) {
    font-size: 24px;
    line-height: 36px;
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    font-family: 'kor/B2-Bold', sans-serif;
    
    br.desc-br {
      display: block;
      
      &::after {
        content: '';
      }
    }
  }
`;

export const DetailText = styled.div`
  color: #1D1D1D;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.015em;
  white-space: pre-wrap;
  margin: 0;
  width: 100%;
  
  @media (max-width: 768px) {
    font-family: Pretendard;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: -0.015em;
    margin: 0;
    margin-bottom: 130px;
    width: 100%;
    width: auto;
    box-sizing: border-box;
    word-break: break-word;
    
    br {
      display: none;
    }
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 40px;
  
  @media (max-width: 768px) {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

export const DownloadButton = styled.button`
  padding: 16px 30px;
  background: #FF4F00;
  border-radius: 50px;
  border: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background: #FF6B33;
  }
  
  @media (max-width: 768px) {
    width: 225px;
    height: 60px;
    min-width: 130px;
    gap: 10px;
    padding: 16px 30px;
    border-radius: 50px;
  }
`;

export const DownloadButtonText = styled.span`
  color: white;
  font-size: 16px;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  line-height: 28px;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    white-space: nowrap;
  }
`;

export const DownloadIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const GrowthSection = styled.div`
  width: 100%;
  padding: 120px 240px;
  background: #FF4F00;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 200px;
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
  
  @media (max-width: 1920px) {
    padding: 120px 240px;
  }
  
  @media (max-width: 1700px) {
    padding: 120px 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 120px 80px;
  }
  
  @media (max-width: 768px) {
    padding: 80px 20px;
    margin-top: 0;
  }
`;

export const GrowthText = styled.p`
  color: white;
  font-size: 32px;
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  line-height: 50px;
  letter-spacing: 0.02em;
  word-wrap: break-word;
  word-break: keep-all;
  overflow-wrap: break-word;
  margin: 0;
  padding-left: 240px;
  
  br {
    display: block;
  }
  
  @media (max-width: 1919px) {
    padding-left: 200px;
  }

  @media (max-width: 1600px) {
    padding-left: 160px;
  }

  @media (max-width: 1440px) {
    padding-left: 80px;
    font-size: 30px;
    line-height: 44px;
  }
  
  @media (max-width: 1300px) {
    padding-left: 80px;
    font-size: 28px;
    line-height: 42px;
  }
  
  @media (max-width: 1100px) {
    padding-left: 80px;
    font-size: 26px;
    line-height: 40px;
  }
  
  @media (max-width: 900px) {
    padding-left: 40px;
    font-size: 24px;
    line-height: 36px;
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -0.01em;
    padding-left: 20px;
  }
`;

export const MobileBreak = styled.br`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    font-size: 0;
    line-height: 0;
    height: 0;
    margin: 0;
    padding: 0;
  }
`;

export const DesktopBreak = styled.br`
  display: block;
  
  @media (max-width: 1920px) and (min-width: 1671px) {
    display: inline;
    
    &::after {
      content: ' ';
      white-space: pre;
    }
  }
  
  @media (max-width: 1670px) and (min-width: 1600px) {
    display: block;
  }
  
  @media (max-width: 1599px) and (min-width: 769px) {
    display: inline;
    
    &::after {
      content: ' ';
      white-space: pre;
    }
  }
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const NumberSpan = styled.span`
  color: #1D1D1D;
  font-size: 32px;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  line-height: 46px;
  margin-right: 0;
  white-space: nowrap;
  display: block;
  margin-bottom: 8px;
  
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 36px;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 0;
  }
`;

export const FeatureSection = styled.div`
  width: 100%;
  padding-bottom: 0;
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
  
  &.feature-first {
    margin-top: 200px !important;
  }
  
  &.feature-second {
    margin-top: 160px !important;
  }
  
  &.feature-third {
    margin-top: 160px !important;
  }
  
  &.third-feature {
    padding-bottom: 200px !important;
  }
  
  @media (max-width: 768px) {
    padding: 0;
    
    &.feature-first {
      margin-top: 130px !important;
    }
    
    &.feature-second {
      margin-top: 117px !important;
    }
    
    &.feature-third {
      margin-top: 110px !important;
    }
    
    &.third-feature {
      padding-bottom: 130px !important;
    }
  }
`;

export const FeatureContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0 240px;
  box-sizing: border-box;
  gap: 140px;
  position: relative;
  
  &.history-feature {
    img {
      width: 588px;
      height: 667px;
      object-fit: contain;
    }
  }

  // 첫 번째 Feature는 좌측 정렬
  &:first-child {
    .feature-content-wrapper {
      margin-right: auto;
    }
  }

  // 두 번째 Feature는 우측 정렬
  &.history-feature {
    .feature-content-wrapper {
      margin-left: auto;
      margin-right: 0;
    }
  }

  // 세 번째 Feature는 좌측 정렬
  &:nth-child(3) {
    .feature-content-wrapper {
      margin-right: auto;
    }
  }
  
  @media (max-width: 1920px) {
    padding: 0 240px;
  }
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0;
    box-sizing: border-box;
    align-items: center;
    gap: 50px;
    justify-content: center !important;
    
    &.history-feature {
      gap: 40px;
    }

    .feature-content-wrapper {
      margin: 0 !important;
    }
  }
`;

export const FeatureContentWrapper = styled.div`
  display: flex;
  gap: 100px;
  width: fit-content;

  .feature-first & {
    gap: 100px;
  }

  .feature-second & {
    gap: 120px;
  }

  .feature-third & {
    gap: 40px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    gap: 50px;

    .feature-first & {
    gap: 50px;
  }

  .feature-second & {
    gap: 50px;
  }

  .feature-third & {
    gap: 50px;
  }

  }
`;

export const FeatureTextColumn = styled.div`
  flex: none;
  width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 0;

  .feature-first & {
    width: 540px;
    justify-content: flex-end;
    padding-bottom: 60px;
  }

  .feature-second & {
    width: 540px;
    justify-content: center;
  }

  .feature-third & {
    width: 500x;
    justify-content: flex-start;
    padding-top: 40px;
  }
  
  @media (max-width: 768px) {
    padding: 0 20px;
    margin-bottom: 0;
    order: 2 !important;
    width: 100%;
    max-width: 100%;
    align-items: flex-start;
    box-sizing: border-box;
    justify-content: flex-start;


     .feature-first & {
      width: 100%;
      justify-content: flex-start;
      padding: 0 20px;
    }

    .feature-second & {
      width: 100%;
      justify-content: flex-start;
      padding: 0 20px;
    }

    .feature-third & {
      width: 100%;
      justify-content: flex-start;
      padding: 0 20px;
    }
  }
`;

export const FeatureImageColumn = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  overflow: visible;
  justify-content: center;
  box-sizing: border-box;
  width: 588px;
  height: 667px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
  }
  
  @media (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 0;
    width: 375px;
    height: 375px;
    order: 1 !important;
    gap: 10px;
    align-items: center;
    justify-content: center;
    
    img {
      width: 375px;
      height: 375px;
      max-width: 375px;
      max-height: 375px;
      object-fit: contain;
    }
  }
`;

export const FeatureTitle = styled.h2`
  color: #1D1D1D;
  font-size: 32px;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  line-height: 46px;
  word-wrap: break-word;
  word-break: break-all;
  overflow-wrap: break-word;
  margin: 0 0 30px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  
  div {
    line-height: 46px;
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 30px;
    order: 1;
    flex-wrap: wrap;
    word-break: break-all;
    
    div {
      line-height: 36px;
      margin-top: 0;
    }

    div span {
      margin-left: 0;
    }
  }
`;

export const FeatureDescription = styled.p`
  color: #1D1D1D;
  font-size: 24px;
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  line-height: 36px;
  margin: 0 0 30px 0;
  white-space: normal;
  
  br {
    display: block;
  }
  
  @media (max-width: 768px) {
    font-family: Pretendard;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: -0.01em;
    margin-bottom: 40px;
    order: 2;
    width: 100%;
    text-align: left;
    
    br {
      display: none;
      
      &::after {
        content: ' ';
      }
    }
  }
`;

export const FeatureLink = styled.button`
  color: #1D1D1D;
  font-size: 16px;
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.3s;
  
  svg {
    margin-left: 8px;
    transition: transform 0.3s;
  }
  
  &:hover {
    opacity: 0.8;
    
    svg {
      transform: translateX(4px);
    }
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 24px;
  }
`;

export const ProjectButton = styled.button`
  padding: 0;
  border-radius: 50px;
  border: 1px solid #DCDCDC;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  background: transparent;
  transition: all 0.3s ease;
  width: 160px;
  height: 60px;
  min-width: 160px;
  max-width: 160px;
  
  &:hover {
    background: white;
    color: #FF4F00;
    border-color: #FF4F00;
  }
  
  @media (max-width: 768px) {
    padding: 0;
    order: 3;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    height: 60px;
    margin-right: 0;
    align-self: flex-start;
  }
`;

export const ProjectButtonText = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  transition: color 0.3s ease;
  text-align: center;
  
  ${ProjectButton}:hover & {
    color: #FF4F00;
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    width: 100%;
    text-align: center;
  }
`;

export const HistorySection = styled.div`
  width: 100%;
  height: 1094px;
  padding: 120px 0;
  background: #F8F8F8;
  position: relative;
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
  overflow: visible;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
  
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    height: 701px;
    padding: 60px 0;
  }
`;

export const HistoryContainer = styled.div`
  width: 100%;
  padding: 0 240px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  position: relative;
  height: auto;
  min-height: 812px;
  box-sizing: border-box;
  overflow: visible;
  
  @media (max-width: 1920px) {
    padding: 0 240px;
  }
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
  }
  
  @media (max-width: 768px) {
    padding: 0 20px;
    flex-direction: column;
    box-sizing: border-box;
    align-items: flex-start;
    height: auto;
    min-height: auto;
  }
`;

export const HistoryLeftColumn = styled.div`
  flex: 0.8;
  padding-right: 40px;
  box-sizing: border-box;
  
  @media (max-width: 1200px) {
    padding-right: 30px;
  }
  
  @media (max-width: 1000px) {
    padding-right: 0;
    margin-bottom: 40px;
    width: 100%;
  }
  
  @media (max-width: 768px) {
    padding-right: 0;
    margin-bottom: 40px;
    padding-left: 0;
    width: 100%;
  }
`;

export const HistoryRightColumn = styled.div`
  flex: 1.2;
  padding-left: 40px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 202px;
  height: calc(100% - 202px);
  box-sizing: border-box;
  
  @media (max-width: 1600px) {
    margin-top: 182px;
    height: calc(100% - 182px);
  }
  
  @media (max-width: 1400px) {
    margin-top: 162px;
    height: calc(100% - 162px);
  }
  
  @media (max-width: 1200px) {
    padding-left: 30px;
    margin-top: 142px;
    height: calc(100% - 142px);
  }
  
  @media (max-width: 768px) {
    padding-left: 0;
    flex-direction: column;
    margin-top: 0;
    height: auto;
    width: 100%;
  }
`;

export const HistoryTitle = styled.h2`
  color: #1D1D1D;
  font-size: 72px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 96px;
  word-wrap: break-word;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 32px;
    font-family: Montserrat;
    font-weight: 700;
    line-height: 40px;
    padding-left: 0;
    margin-left: 0;
  }
`;

export const HistorySubtitle = styled.p`
  color: #5C5C5C;
  font-size: 24px;
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  line-height: 36px;
  word-wrap: break-word;
  margin: 10px 0 60px;
  
  @media (max-width: 768px) {
    color: #5C5C5C;
    font-size: 16px;
    font-family: Pretendard;
    font-weight: 400;
    line-height: 24px;
    margin: 10px 0 0;
    padding-left: 0;
    margin-left: 0;
  }
`;

export const YearTabs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-right: 64px;
  margin-top: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
  
  @media (max-width: 1200px) {
    margin-right: 40px;
  }
  
  @media (max-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
    gap: 16px;
    margin-bottom: 20px;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    position: relative;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-right: 300px;
    
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 250px;
      height: 100%;
      background: linear-gradient(to right, #F8F8F800 0%, #F8F8F866 40%, #F8F8F8CC 70%, #F8F8F8 100%);
      pointer-events: none;
      z-index: 1;
    }
    
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 30px;
      width: 12px;
      height: 12px;
      border-right: 3px solid #FF4F00;
      border-bottom: 3px solid #FF4F00;
      transform: translateY(-50%) rotate(-45deg);
      z-index: 2;
      animation: arrowBlink 1.2s infinite ease-in-out;
    }
  }
`;

export const YearTab = styled.button<{ active: boolean }>`
  color: ${props => props.active ? '#FF4F00' : '#DCDCDC'};
  font-size: 72px;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  line-height: 96px;
  word-wrap: break-word;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-align: left;
  transition: color 0.3s, transform 0.5s ease;
  
  &:first-child {
    padding-top: 0;
    margin-top: 0;
  }
  
  &:hover {
    color: ${props => props.active ? '#FF4F00' : '#AAAAAA'};
  }
  
  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 46px;
    white-space: nowrap;
    transform: none !important;
  }
`;

export const HistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 0;
  position: relative;
  min-height: 400px;
  height: 100%;
  transition: opacity 0.5s ease;
  gap: 40px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  overflow-y: auto;
  box-sizing: border-box;
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
    width: 0;
    height: 0;
  }
  
  @media (max-width: 1200px) {
    min-height: auto;
    height: auto;
    gap: 30px;
  }
  
  @media (max-width: 1000px) {
    flex-direction: column;
    margin-top: 0;
    min-height: auto;
    height: auto;
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 0;
    min-height: auto;
    height: auto;
    gap: 20px;
  }
`;

export const HistoryText = styled.p`
  color: #1D1D1D;
  font-size: 24px;
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  line-height: 36px;
  word-wrap: break-word;
  padding-top: 5px;
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    color: #1D1D1D;
    font-size: 16px;
    font-family: Pretendard;
    font-weight: 400;
    line-height: 26px;
    word-wrap: break-word;
    padding-right: 0;
    padding-left: 0;
    margin-left: 0;
    margin-bottom: 0;
    margin-top: 20px;
  }
`;

export const HistoryImage = styled.img`
  width: 558px;
  height: 331px;
  border-radius: 20px;
  object-fit: cover;
  position: static;
  transition: opacity 0.5s ease, transform 0.5s ease;
  
  @media (max-width: 1600px) {
    width: 466px;
    height: 308px;
  }
  
  @media (max-width: 1400px) {
    width: 480px;
    height: 285px;
  }
  
  @media (max-width: 1200px) {
    width: 450px;
    height: 267px;
  }
  
  @media (max-width: 1100px) {
    width: 420px;
    height: 249px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    aspect-ratio: 558/331;
    margin-bottom: 0;
    margin-right: 0;
    margin-left: 0;
  }
`;

export const ValueSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: calc(100% - 480px);
  margin: 120px auto 0;
  opacity: 0;
  animation: ${fadeInUp} 1s forwards;
  animation-delay: 0.5s;
  
  @media (max-width: 768px) {
    margin: 60px auto 0;
    padding: 0 20px;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const IntroContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: calc(100% - 480px);
  margin: 120px auto 0;

  @media (max-width: 768px) {
    margin: 60px auto 0;
    padding: 0 20px;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const MainImageWrapper = styled.div`
  width: 100%;
  max-width: calc(100% - 480px);
  margin: 0 auto;
  margin-top: 120px;
  
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 60px;
  }
  
  img {
    width: 100%;
    object-fit: contain;
  }
`;

export const ValueItemContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 45px;
  border-radius: 15px;
  background-color: #FFFFFF;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 30px;
  }
`;

export const MarketingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: 12%;
  width: 100%;
  opacity: 0;
  animation: ${fadeIn} 1.2s ease forwards;
  animation-delay: 1.8s;
  
  @media (max-width: 768px) {
    position: relative;
    bottom: auto;
    margin-top: 0;
    padding-top: 15px;
    padding-bottom: 15px;
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const HeadersRow = styled.div`
  display: flex;
  width: 100%;
  max-width: 900px;
  margin-bottom: 16px;
  position: relative;
  height: 40px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    height: auto;
    margin-bottom: 30px;
    padding: 0;
  }
`;

export const HeaderWrapper = styled.div`
  position: absolute;
  white-space: nowrap;
  text-align: center;
  opacity: 0;
  animation: ${fadeIn} 1s ease forwards;
  
  &.growth {
    left: 34%;
    transform: translateX(-50%);
    animation-delay: 0.3s;
  }
  
  &.brand {
    right: calc(12.5% - 20px);
    transform: translateX(50%);
    animation-delay: 0.6s;
  }
  
  @media (max-width: 768px) {
    position: static;
    width: 100%;
    margin-bottom: 10px;
    
    &.growth {
      left: auto;
      transform: none;
    }
    
    &.brand {
      right: auto;
      transform: none;
    }
  }
`;

export const ColumnsRow = styled.div`
  display: flex;
  width: 100%;
  max-width: 900px;
  gap: 50px;
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(25% - 22.5px);
  position: relative;
  opacity: 0;
  animation: ${fadeIn} 1s ease forwards;
  
  &:nth-child(1) {
    animation-delay: 0.8s;
  }
  
  &:nth-child(2) {
    animation-delay: 1.0s;
  }
  
  &:nth-child(3) {
    animation-delay: 1.2s;
  }
  
  &:nth-child(4) {
    padding-left: 20px;
    margin-left: 10px;
    position: relative;
    animation-delay: 1.4s;
    
    &:before {
      content: '';
      position: absolute;
      left: -60px;
      top: -15px;
      height: calc(100% + 30px);
      width: 1px;
      background-color: #dcdcdc;
    }
  }
  
  @media (max-width: 768px) {
    width: 80%;
    margin-bottom: 15px;
    align-items: center;
    
    &:nth-child(4) {
      padding-left: 0;
      margin-left: 0;
      padding-top: 20px;
      margin-top: 5px;
      border-top: 1px solid #dcdcdc;
      
      &:before {
        display: none;
      }
    }
  }
  
  @media (max-width: 480px) {
    width: 90%;
  }
`;

export const SectionTitle = styled.p<{ color?: string, isHeader?: boolean }>`
  margin: 6px 0;
  color: ${props => {
    if (props.color === 'orange') return '#FF7A00';
    if (props.color === 'yellow') return '#FFC800';
    return '#999';
  }};
  font-weight: ${props => props.color === 'gray' ? 'normal' : 'bold'};
  font-family: 'Montserrat', sans-serif;
  text-align: ${props => props.color === 'gray' ? 'left' : 'center'};
  font-size: ${props => props.isHeader ? '28px' : '19px'};
  letter-spacing: -0.02em;
  
  @media (max-width: 1600px) {
    font-size: ${props => props.isHeader ? '26px' : '18px'};
  }
  
  @media (max-width: 1400px) {
    font-size: ${props => props.isHeader ? '25px' : '17px'};
  }
  
  @media (max-width: 1200px) {
    font-size: ${props => props.isHeader ? '24px' : '16px'};
  }
  
  @media (max-width: 992px) {
    font-size: ${props => props.isHeader ? '23px' : '16px'};
  }
  
  @media (max-width: 768px) {
    font-size: ${props => props.isHeader ? '22px' : '16px'};
    margin: 4px 0;
    text-align: center;
  }
`;
